// import consts
import { dynamicAssets } from 'js/constants/Paths';

export const parseData = (data) => {
  const locationIds = [];
  const locationsById = {};

  if (data) {
    data.map((item, index) => {
      item.previousItem = false;
      item.nextItem = false;
      // get previous item if avaiable
      const previousItem = data[index - 1] || false;

      // get next item if avaiable
      const nextItem = data[index + 1] || false;

      if (previousItem) {
        item.previousItem = {
          name: previousItem.name,
          friendly_url: '/explore-porthole/' + previousItem.friendly_url,
        };
      }

      if (nextItem) {
        item.nextItem = {
          name: nextItem.name,
          friendly_url: '/explore-porthole/' + nextItem.friendly_url,
        };
      }

      item.displayInCarousel = false;

      if (item.header_image && item.header_image !== '') {
        item.header_image = dynamicAssets(item.header_image);
      }

      if (item.cta_image && item.cta_image !== '') {
        item.cta_image = dynamicAssets(item.cta_image);
      }

      if (item.location_image && item.location_image !== '') {
        item.location_image = dynamicAssets(item.location_image);
      }

      if (item.secondary_location_image && item.secondary_location_image !== '') {
        item.secondary_location_image = dynamicAssets(item.secondary_location_image);
      }

      if (item.also_spot_section && !Array.isArray(item.also_spot_section)) {
        if (item.also_spot_section.also_spot_image !== '') {
          item.also_spot_section.also_spot_image = dynamicAssets(item.also_spot_section.also_spot_image);
        }
      }

      item.full_url = '/explore-porthole/' + item.friendly_url;

      locationIds.push(item.id);
      locationsById[item.id] = item;
    });
  }

  return { locationsById, locationIds };
};
